import React from 'react';

import * as S from './CircularLoaderStyle';

const CircularLoader = ({ ldrWidth, ldrHeight, pageLoader, bdrColor }) => (
	<>
		<S.Loader $ldrWidth={ldrWidth} $ldrHeight={ldrHeight} $pageLoader={pageLoader} $bdrColor={bdrColor}>
			<div />
			<div />
			<div />
			<div />
		</S.Loader>
		{pageLoader && <S.LoaderShadow />}
	</>
);

export default CircularLoader;
